import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { ActivityTrackingService } from '@core/services/activity-tracking.service';
import { isApiRequest } from './api-request.guard';

/**
 * Refreshes the auto-logout activity ticket on a successful backend response.
 * Fires only on the final `HttpResponse` (not on intermediate events such as
 * upload progress).
 */
export const activityTrackingInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isApiRequest(req.url)) {
    return next(req);
  }

  const activityTrackingService = inject(ActivityTrackingService);

  return next(req).pipe(
    tap((event) => {
      if (event instanceof HttpResponse) {
        activityTrackingService.trackActivity(req.url);
      }
    }),
  );
};
